import React, { useState, useEffect } from 'react';
import { createUseStyles } from 'react-jss'

import 'moment/locale/ru';
import locale from 'antd/es/date-picker/locale/ru_RU';
import {
    Form,
    Input,
    Select,
    Checkbox,
    DatePicker,
    InputNumber,
    Tooltip,
    Tabs,
    Typography,
    Tag
} from 'antd';
import Icofont from 'react-icofont';
import { errorCatch, getDisplay, getFieldDisplay, GetMeta, GetMetaProperties, getObjectDisplay, getObjectValue, metaGetFieldByName, QueryDetail, QueryParams, READWITH, uncapitalize } from '../../components/Tool';
import { useSelector } from 'react-redux';
import moment from 'moment';
import AbstractCollection from '../AbstractCollection';
import Field from '../Field';
import CollectionServer from '../CollectionServer';
var _ = require('lodash');

const { Option } = Select;
const { TabPane } = Tabs;
const { Text, Link } = Typography;
const { CheckableTag } = Tag;

const useStyles = createUseStyles({
    FormNav: {
        display: "flex",
        justifyContent: "space-between",
        paddingBottom: "10px",
    },
    FormItem: {
    },
    Field: {},
    Unknown: {},
    Obj: {},
    Time: {},
    Boolean: {},
    Float: {},
    Integer: {},
    String: {},
    Frm: {},
})

function isRequired(item) {
    if (item && item.validators) {
        return item.validators.required;
    }

    return false;
}

function Frm(props) {
    const classes = useStyles()
    const { auth, form, meta, options, object, submit, funcStat, contextFilters } = props;
    const [visible, setVisible] = useState(false);
    const [excludeFields, setExcludeFields] = useState({});
    const [fieldsFilters, setFieldsFilters] = useState({});
    useEffect(() => {
        form.resetFields();
    }, []);
    useEffect(() => {
        let fldFlt = {};
        let ctxFlt = {};
        if (contextFilters) {
            let ctx = contextFilters();
            if (_.isArray(ctx)) {
                ctx.forEach(item => {
                    if (item.action) {
                        ctxFlt[item.name.toLowerCase()] = item.value;
                    } else {
                        fldFlt[item.name.toLowerCase()] = item.value;
                    }
                });
            }
        }
        setFieldsFilters(fldFlt);
        setExcludeFields(ctxFlt);
    }, [contextFilters]);

    const gmeta = useSelector(state => state.meta);
    const filtersFromMeta = React.useCallback((name) => {
        let prop = [];
        let p = _.get(gmeta[name.toLowerCase()], "properties");
        if (p) {
            prop = p.filter(e => _.get(e, "relation.type") !== "one-many").map(e => ({ ...e, sort: true, filter: true, func: (e.filterType == "range") ? ["min", "max"] : undefined }))
        }
        return prop;
    }, [gmeta]);

    var properties = GetMetaProperties(meta);
    if (!properties) return <></>;
    const propertiesFiltered = properties.filter(e => e.name.toUpperCase() !== "ID").filter(e => (!e.relation || (e.relation && e.relation.type !== "one-many")));
    const propertiesOneMany = properties.filter(e => e.relation && e.relation.type === "one-many");
    const propertiesDocuments = properties.filter(e => e.type === "document");

    return (
        <div>
            {(object && propertiesOneMany && propertiesOneMany.length > 0) &&
                <div className={classes.FormNav}>
                    <div>
                        {(meta.name && visible == true) && getObjectDisplay(object, meta.name, gmeta)}
                    </div>
                    <div>
                        <Tooltip title="Связи">
                            <CheckableTag
                                checked={visible}
                                onChange={checked => setVisible(checked)}
                            >
                                <Icofont icon="icofont-link-alt" />
                            </CheckableTag>
                        </Tooltip>
                    </div>
                </div>}
            <div style={{ display: (!visible) ? "block" : "none" }}>
                <Form form={form}
                    onFinish={submit}
                    {...options}
                    labelAlign={"left"}
                    layout={"vertical"}>
                    {propertiesFiltered.filter(e => (excludeFields[e.name.toLowerCase()]) ? false : true).map((item, idx) => {
                        return (
                            <Form.Item className={classes.FormItem}
                                key={item.name}
                                name={(item.type !== "object" && item.type !== "document") ? uncapitalize(item.name) : uncapitalize(item.name) + "ID"}
                                label={(item.type !== "bool" && item.type !== "boolean") ? item.label : undefined}
                                rules={[{ required: isRequired(item), message: 'Укажите ' + item.label.toLowerCase() + '!' }]}
                            >
                                <Field
                                    mode="model"
                                    className={classes.Field}
                                    key={item.name}
                                    auth={auth}
                                    filter={fieldsFilters[item.name.toLowerCase()]}
                                    item={{ ...item, filterType: undefined, func: (funcStat && funcStat[item.name.toLowerCase()]) ? funcStat[item.name.toLowerCase()] : {} }}
                                // value={object[item.name]}
                                // onChange={(value) => onFilterChange(value, item)}
                                />
                            </Form.Item>
                        );
                    })}
                </Form>
            </div>
            <div style={{ display: (visible) ? "block" : "none" }}>
                <Tabs>
                    {propertiesOneMany.map((e, idx) => {
                        let p = getObjectValue(e, "relation.reference.property");
                        let n = getObjectValue(e, "relation.reference.object");
                        if (!n) return;
                        // let o = gmeta[n.toLowerCase()];
                        return (<TabPane tab={e.label} key={idx}>
                            <CollectionServer
                                auth={auth}
                                name={n.toLowerCase()}
                                contextFilters={() => (object)?[
                                    {
                                        action: true,
                                        // method: "eq",
                                        name: p,
                                        value: object.ID
                                    }
                                ]:[]}
                                filters={() => filtersFromMeta(n.toLowerCase())}
                                // filters={() => [
                                //     {
                                //         label:"Идентификатор",
                                //         name: "id",
                                //         sort: true,
                                //     }
                                // ]}

                                columns={({ auth, collection, setCollection, request }) => [
                                    {
                                        key: "0",
                                        title: "ID",
                                        render: (text, record, index) => {
                                            return (record.ID);
                                        },
                                        width: 45,
                                    },
                                    {
                                        key: "meta",
                                        title: "Описание",
                                        render: (text, record, index) => {
                                            return (getObjectDisplay(record, n, gmeta));
                                        }
                                    }
                                ]}

                                // mode={"list"}
                                // render={(item, idx, { setCollection, setCollectionItem, removeCollectionItem, update }) => (<div>
                                //     {getObjectDisplay(item, n, gmeta)}
                                // </div>)}

                                form={Model}
                                size={"small"}
                                // titleFunc={(title) => "Заказы"}
                                defaultModelActions={true}
                                defaultCollectionActions={true}
                            />
                        </TabPane>
                        )
                    })}
                </Tabs>
                {/* {propertiesDocuments.length > 0 && <div>
                    <Text strong>Документы</Text>
                    {propertiesDocuments.sort((a, b) => {
                        if (a.label < b.label) {
                            return -1;
                        }
                        if (a.label > b.label) {
                            return 1;
                        }
                        return 0;
                    }).map((e, idx) => (
                        <div key={idx} style={{ paddingLeft: "10px" }}>
                            <Link href="#">
                                {e.label}
                            </Link>
                        </div>
                    ))}
                </div>} */}
            </div>
        </div>
    )
}

export default function Model(props) {
    const classes = useStyles()
    const { auth, meta, options, object, form, submit, funcStat, contextFilters } = props;
    var xmeta = GetMeta(meta);
    if (!xmeta) return <></>;
    return (
        <>
            {<Frm className={classes.Frm} auth={auth} form={form} contextFilters={contextFilters} submit={submit} meta={meta} options={options} object={object} funcStat={funcStat}></Frm>}
        </>
    )
};
